import { NoteEntity } from './note-entity.model';

export class Note {
  constructor(
    public id = 0,
    public subject = '',
    public description = '',
    public category_id = 0,
    public started = '',
    public pinned = false,
    public provided_by_contact = false,
    public entities: Partial<NoteEntity>[] = null,
    public contacts: Partial<NoteEntity>[] = null,
    public createTask = false,
    public has_followup = false,
    public user = '',
    public user_id = 0,
  ) {}
}
